export default {
  title: 'Points Products',
  // Top buttons
  addGift: 'Add Gift',
  // Search bar
  giftInfo: 'Gift Info',
  giftInfoPlaceholder: 'Search keyword',
  category: 'Category',
  publishStatus: 'Status',
  // Batch
  batchSetStock: 'Batch Set Stock',
  batchOnline: 'Batch Online',
  batchOffline: 'Batch Offline',
  batchOnlineConfirm: 'Put selected items online?',
  batchOfflineConfirm: 'Take selected items offline?',
  batchSetStockTitle: 'Batch Set Stock',
  batchSetStockPlaceholder: 'Enter stock quantity',
  batchSetStockTip: 'Apply unified stock to {count} selected gifts',
  selectFirstTip: 'Please select items first',
  // Columns
  exchangePrice: 'Exchange Price',
  exchangedQty: 'Exchanged Qty',
  stock: 'Stock',
  status: 'Status',
  online: 'Online',
  offline: 'Offline',
  createTime: 'Create Time',
  // Actions
  edit: 'Edit',
  delete: 'Delete',
  deleteConfirm: 'This action is irreversible. Confirm delete?',
  // Inline stock edit
  editStock: 'Edit Stock',
  stockRequired: 'Please enter stock quantity',
  // Add gift - steps
  stepSelectGift: 'Select Gift',
  stepGiftConfig: 'Gift Config',
  addGiftTitle: 'Add Gift',
  editGiftTitle: 'Edit Gift',
  giftLibCategory: 'Gift Library Category',
  pricePerYuan: 'Price (CNY)',
  giftType: 'Gift Type',
  giftTypeAll: 'All',
  giftTypePhysical: 'Physical',
  giftTypeVirtual: 'Virtual',
  stockCount: 'Stock Count',
  selectAction: 'Select',
  giftSnLabel: 'No.',
  giftNo: 'Gift No.',
  // Step 2
  selectedGift: 'Selected Gift',
  marketPrice: 'Market Price',
  exchangePriceLabel: 'Exchange Price',
  pointsPay: 'Points Pay',
  exchangeQty: 'Exchangeable Qty',
  specInfo: 'Spec Info',
  specStock: 'Spec Stock',
  exchangePriceCol: 'Exchange Price',
  pointsUnit: 'Points',
  inputPlaceholder: 'Please input',
  virtualExchange: 'Virtual Exchange',
  virtualExchangePlaceholder: 'Enter virtual exchange qty',
  listSort: 'List Sort',
  listSortPlaceholder: 'Please input',
  publish: 'Publish Now',
  // Validation
  categoryRequired: 'Please select category',
  exchangePriceRequired: 'Please select exchange price',
  specStockRequired: 'Please enter spec stock',
  specPriceRequired: 'Please enter exchange price',
};
